import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import {faUserSecret} from "@fortawesome/pro-regular-svg-icons";
import ChangeAccountPasswordForm from "./ChangeAccountPasswordForm";


const ChangeAccountPasswordButton = ({userAccount}) => {
    const [showDialog, setShowDialog] = React.useState(false);

    return (
        <React.Fragment>
            <Button
                color="primary"
                onClick={handleOpen}
                variant={'text'}
                // size={'small'}
            >
                <FontAwesomeIcon
                    icon={faUserSecret}
                    fixedWidth
                />
                &nbsp;Change Password
            </Button>

            <Dialog
                open={showDialog}
                onClose={handleClose}
                aria-labelledby="jeff-credit-dialog-title"
                aria-describedby="jeff-credit-description"
                maxWidth={'md'}
                fullWidth={true}
            >
                <DialogTitle id="account-dialog-title">Change Password</DialogTitle>
                <DialogContent>
                    <ChangeAccountPasswordForm
                        accountUID={userAccount.account_uid}
                        doneCallback={handleClose}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );

    function handleOpen() {
        setShowDialog(true);
    }

    function handleClose() {
        setShowDialog(false);
    }
};


export default ChangeAccountPasswordButton;